import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})
export default {
  data: null,
  columns: [
    {
      label: '培训id',
      prop: 'trainCode'
    },
    {
      label: '培训名称',
      prop: 'name'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '培训类别',
      prop: 'type'
    },
    {
      label: '班级人数',
      prop: 'classCount'
    },
    {
      label: '培训开始时间',
      prop: 'trainStartTime'
    },
    {
      label: '培训场地',
      prop: 'placesName'
    },
    {
        label: '教练名称',
        prop: 'coachName'
    },
    {
        label: '会员账号',
        prop: 'mbMobile'
    },
    {
      label: '家长账号',
      prop: 'parentMemberMobile'
    },
    {
        label: '年龄',
        prop: 'mbAge'
    },
    {
          label: '会员类型',
          prop: 'mbType'
    },
    {
      label: '会员姓名',
      prop: 'mbName'
    },
    {
        label: '性别',
        prop: 'mbGender'
    },
    {
        label: '级别',
        prop: 'mbLevel'
    },
    {
        label: '支付状态',
        prop: 'payStatus'
    }
  ]
}
